function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhatNext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Heading = require("../Heading");
var _Text = require("../Text");
var _Button = require("../Button");
var _View = require("../View");
var _SvgImage = require("../SvgImage");
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var WhatNext = exports.WhatNext = (0, _react.memo)(function (_ref) {
  var data = _ref.data,
    style = _ref.style;
  var _ref2 = data || {},
    slug = _ref2.slug,
    title = _ref2.title,
    body = _ref2.body,
    linkLabel = _ref2.linkLabel,
    url = _ref2.url,
    nativeUrl = _ref2.nativeUrl;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var navigationContext = (0, _utils.useNavigationContext)();
  var configurationContext = (0, _react.useContext)(_utils.ConfigurationContext);
  var isFirefly = (configurationContext == null ? void 0 : configurationContext.ClientApplication) === 'firefly';
  var _linkUrl = isFirefly ? nativeUrl : url;
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _trackingSource = slug;
  var _onPress = function _onPress() {
    trackEvent({
      eventName: trackingEvents.whatNext,
      props: {
        source: _trackingSource,
        type: 'what next button'
      }
    });
    var transformedUrl = navigationContext.transform(_linkUrl || '');
    navigationContext.navigate(transformedUrl);
  };
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.container, style],
    testID: "WhatNext",
    children: [(0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
      style: styles.butterfly,
      children: (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
        image: require("../../images/Butterfly.svg"),
        style: styles.backgroundImage
      })
    }), (0, _jsxRuntime.jsx)(_Heading.Heading, {
      style: styles.heading,
      level: 2,
      children: title
    }), (0, _jsxRuntime.jsx)(_Text.Text, {
      containerStyle: styles.textContainer,
      textStyle: styles.text,
      children: body
    }), (0, _jsxRuntime.jsx)(_Button.Button, {
      label: linkLabel,
      onPress: _onPress,
      type: _Button.ButtonType.brand
    })]
  });
});